import scsConfig from './scs';

describe('SCS minimum standards guidance', () => {
  it('links every minimum standards page to GOV.UK guidance', () => {
    const section = scsConfig.sections.find(({ slug }) => slug === 'minimum-standard');
    const descriptions = section?.subsections.flatMap(({ pages }) =>
      pages.map(({ description }) => description),
    );

    expect(descriptions).toHaveLength(4);
    for (const description of descriptions || []) {
      expect(description).toContain(
        "You should agree how you will determine whether you have 'met' these standards.",
      );
      expect(description).toContain(
        '<a href="https://www.gov.uk/government/publications/senior-civil-service-performance-management" target="_blank" rel="noopener noreferrer">gov.uk</a>',
      );
      expect(description).not.toContain('SCS_Minimum_Standards_AW_3nspT0U.pdf');
    }
  });

  it('shows updated leadership guidance with both supporting links', () => {
    const section = scsConfig.sections.find(({ slug }) => slug === 'minimum-standard');
    const leadership = section?.subsections.find(({ slug }) => slug === 'leadership');
    const page = leadership?.pages[0];
    const hint = page?.pageType === 'question' ? page.questions?.[0].hint : undefined;

    expect(hint).toContain(
      'It is important that members of the SCS demonstrate, and evidence, positive leadership and management of people',
    );
    expect(hint).toContain('poor performance is actively managed');
    expect(hint).toContain(
      '[Success Profiles](https://www.gov.uk/government/publications/success-profiles/success-profiles-civil-service-behaviours)',
    );
    expect(hint).toContain(
      '[CO Leadership Commitments](https://intranet.cabinetoffice.gov.uk/about-the-cabinet-office/governance-and-leadership/new-leadership-commitments/)',
    );
    expect(hint).not.toContain('Behaviours should be treated with equal weight');
  });

  it('shows updated corporate guidance', () => {
    const section = scsConfig.sections.find(({ slug }) => slug === 'minimum-standard');
    const corporate = section?.subsections.find(({ slug }) => slug === 'corportate');
    const page = corporate?.pages[0];
    const hint = page?.pageType === 'question' ? page.questions?.[0].hint : undefined;

    expect(hint).toContain(
      'Each SCS member is expected to undertake an activity that goes above and beyond the day-to-day role.',
    );
    expect(hint).toContain(
      'SCS should contribute to its collective running, performance, culture and reputation, beyond their business unit and immediate responsibilities.',
    );
    expect(hint).toContain(
      'Actively deliver organisation-wide and/or cross government initiatives by embedding them into their work and enabling teams to understand and contribute to these.',
    );
    expect(hint).not.toContain('There is an expectation that each SCS member');
    expect(hint).not.toContain('In the instances where the contribution sits');
  });
});
